export default __webpack_public_path__ + "static/media/txt1_sp.a785ccdf.png";